// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(min-width: 1025px)";
var _3 = "container-2YRaq";
var _4 = "switch__error-26M1f";
var _5 = "loyalty__desc-1tbPf";
var _6 = "disabilities__text-K0PiV";
var _7 = "checkboxes-2z9lx";
var _8 = "container_icon-dr18L";
var _9 = "identity-1sXRk";
var _a = "documents-3z33u";
var _b = "loyalty-3TvGG";
var _c = "disabilities-SUMeG";
export { _1 as "__esModule", _2 as "laptop", _3 as "container", _4 as "switch__error", _5 as "loyalty__desc", _6 as "disabilities__text", _7 as "checkboxes", _8 as "container_icon", _9 as "identity", _a as "documents", _b as "loyalty", _c as "disabilities" }
export default { "__esModule": _1, "laptop": _2, "container": _3, "switch__error": _4, "loyalty__desc": _5, "disabilities__text": _6, "checkboxes": _7, "container_icon": _8, "identity": _9, "documents": _a, "loyalty": _b, "disabilities": _c }
